import { createDeclareType, createTypeFactory } from '../utilsTs/declareTypes';

/** 日志类型对象 */
export const LoggerTypes = createTypeFactory({
    /** 操作日志 */
    op: { id: 'OP', name: '操作日志' },
    /** 系统日志 */
    system: { id: 'SYSTEM', name: '系统日志' },
    /** 支付日志 */
    pay: { id: 'PAY', name: '支付日志' },
    /** 会员日志 */
    membership: { id: 'MEMBERSHIP', name: '会员日志' },
    /** 礼品卡日志 */
    giftCard: { id: 'GIFTCARD', name: '礼品卡日志' }
} as const);

/** 日志类型 */
export declare type LoggerType = createDeclareType<typeof LoggerTypes>;

/** 日志string类型 */
export type LoggerStringType = ReturnType<typeof LoggerTypes.getIds>[number];